
namespace GeniuzPOS.AdvPromo {
    export class Adv05ItemDetailsColumns {
        static columnsKey = 'AdvPromo.Adv05ItemDetails';
    }
}